module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1 && _vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "操作说明",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v(" 怡康店铺类型设置 ")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.dialogOpen()
      }
    }
  }, [_vm._v("添加店铺类型")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "shop_type_name",
      "label": "店铺类型名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shop_type_comment",
      "label": "店铺类型描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sort",
      "label": "排序"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "是否启用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == '0') ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("启用")]) : _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("禁用")])]
      }
    }], null, false, 3489158194)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('router-link', {
          staticClass: "iconfont icon-edit1",
          attrs: {
            "to": {
              path: _vm.matchHidePage('editor'),
              query: {
                shop_type_id: scope.row.shop_type_id
              }
            }
          }
        })], 1)]
      }
    }], null, false, 331800393)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b27ae34", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b27ae34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/shopstypes/list.vue
// module id = 2799
// module chunks = 0